import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=05106a29&scoped=true&"
import script from "./DraggableList.vue?vue&type=script&lang=js&"
export * from "./DraggableList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=05106a29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05106a29",
  null
  
)

export default component.exports